<template>
    <header class="cielo-header">
        <div class="cielo-header__container">
            <div class="cielo-header__logo">
                <img v-if="!isCustomizationEnabled" src="@/assets/img/logo-cielo.svg" :alt="$ml.get('altLogo')" tabindex="0" />

                <img v-else-if="!hasLogo" src="@/assets/img/logo-cielo.svg" :alt="$ml.get('altLogo')" tabindex="0" />

                <MerchantLogoV2 v-else />

                <div v-if="testModeEnabled" style="font-size: 10px" class="badge badge-pill badge-danger">
                    MODO DE TESTES
                </div>
            </div>

            <div class="cielo-header__lang-flags">
                <div class="cielo-header__langs">
                    <ul class="cielo-header__flags-list" tabindex="0" :aria-label="$ml.get('ariaLangList')">
                        <li class="cielo-header__flags-list-item">
                            <button class="cielo-header__flag-cta" @click="setLocalize('pt-br')" :aria-label="$ml.get('altLangBr')">
                                <img class="lang" src="@/assets/img/brazil.png" alt="" tabindex="-1" />
                            </button>
                        </li>
                        <li class="cielo-header__flags-list-item">
                            <button class="cielo-header__flag-cta" @click="setLocalize('en')" :aria-label="$ml.get('altLangEn')">
                                <img class="lang" src="@/assets/img/gbrit.png" alt="" tabindex="-1" />
                            </button>
                        </li>
                        <li class="cielo-header__flags-list-item">
                            <button class="cielo-header__flag-cta" @click="setLocalize('es-es')" :aria-label="$ml.get('altLangEs')">
                                <img class="lang" src="@/assets/img/spain.png" alt="" tabindex="-1" />
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
</template>

<style lang="scss" scoped>
  .cielo-header {
      background: #FFF;

      @media screen and (min-width: 1025px) {
          border-bottom: 1px solid #B8C1CC;
      }

      &__container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px;

          @media screen and (min-width: 1025px) {
              max-width: 1180px;
              margin: 0 auto;
              padding: 20px 16px;
          }

          @media screen and (min-width: 1165px) {
              padding: 20px 0;
          }
      }

      &__logo {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          img {
              width: 80px;
              height: auto;
              margin-right: 8px;
          }
      }

      &__lang-flags {
          display: flex;
          align-items: center;
      }

      &__security {
          display: flex;
          flex-direction: column;
          margin-right: 4px;

          p {
              margin: 0;
          }

          strong {}

          p,
          strong {
              font-size: 12px;
              line-height: 12px;
              font-weight: 600;
              color: #75879C;

              @media screen and (min-width: 1025px) {
                  line-height: 14px;
              }
          }
      }

      &__langs {
          display: flex;
          align-items: center;
      }

      &__flags-list {
          display: flex;
          list-style-type: none;
          margin: 0;
          padding: 0;
      }

      &__flags-list-item {}

      &__flag-cta {
          border: none;
          background-color: transparent;
          padding: 0 4px;
          display: flex;
          justify-content: center;
      }
  }
</style>

<script>
  import { mapState } from 'vuex';
  import MerchantLogoV2 from '@/components/MerchantLogoV2';

  export default {
      components: {
          MerchantLogoV2
      },
      computed: {
          ...mapState({
              testModeEnabled: state => state.preorder.TestModeEnabled,
              isCustomizationEnabled: state => state.merchantLayout.IsCustomizationEnabled,
              hasLogo: state => state.merchantLayout.HasLogo
          }),
      },
  methods: {
    setLocalize : function(localeName) {
      this.$ml.change(localeName);
      if(localeName == 'pt-br')
        localeName = 'pt_BR';
      else if(localeName == 'es-es')
        localeName = 'es';
      import(`vee-validate/dist/locale/${localeName}`).then(locale => {
        this.$validator.localize(localeName, locale);
        this.currentLocale = localeName;
      });
    },
  }
  };
</script>
